import {
  HYDRATE,
  type HydrateAction,
} from '@/domains/core/applicationState/store/hydrateAction';

import type { SpartacuxProductDiscoveryDomainState } from '../../productDiscovery.model';
import {
  FETCH_SPONSORED_PRODUCTS_FAILED,
  FETCH_SPONSORED_PRODUCTS_SUCCESS,
  FETCHING_SPONSORED_PRODUCTS,
  type Action,
} from './actions';
import {
  sponsoredProductInitialState,
  type SponsoredProductsState,
} from './model';
import { selectSponsoredProductsState } from './selectors/sponsoredProducts';

export function sponsoredProductsReducer(
  state: SponsoredProductsState = sponsoredProductInitialState,
  action: Action | HydrateAction<SpartacuxProductDiscoveryDomainState>,
) {
  switch (action.type) {
    case HYDRATE:
      return {
        ...state,
        ...selectSponsoredProductsState(action.state),
      };

    case FETCHING_SPONSORED_PRODUCTS:
      return {
        ...state,
        fetching: true,
      };

    case FETCH_SPONSORED_PRODUCTS_SUCCESS:
      return {
        ...state,
        fetching: false,
        items: action.sponsoredProducts,
        positions: action.positions || [],
      };

    case FETCH_SPONSORED_PRODUCTS_FAILED:
      return {
        ...state,
        fetching: false,
        error: action.error.message,
      };

    default:
      return state;
  }
}
